import FolderIcon from '~/assets/svg/newSvg/folder.svg?react';
import DeleteIcon from '~/assets/svg/newSvg/basket.svg?react';
import EditIcon from '~/assets/svg/newSvg/edit.svg?react';
import CheckIcon from '~/assets/svg/newSvg/mark-icon.svg?react';
import CloseIcon from '~/assets/svg/newSvg/close-cross.svg?react';
import styles from './AssetFolderCard.module.scss';
import { IFolders } from '~/utils/types/storage';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { IconButton, Spinner } from '~/ui';
import ModalConfirm from '~/components/Shared/ModalConfirm';

interface IFolderCardProps {
  data: IFolders;
  editedNameId: number | null;
  setEditedNameId: (value: number | null) => void;
  refetchAsset: () => void;
  isUpdating: boolean;
  onClick: (value: string) => void;
  onDelete: (id: number) => void;
  setActiveFolder: (id: number) => void;
}

export const AssetFolderCard = ({
  data,
  editedNameId,
  setEditedNameId,
  isUpdating,
  onDelete,
  onClick,
  setActiveFolder,
}: IFolderCardProps) => {
  const { t } = useTranslation();
  const { id, name, files, child_folders } = data;
  const [editedName, setEdiedName] = useState('');

  const filesLingth = files.length;
  const childFoldersLength = child_folders.length;

  const totalObjectsLength = filesLingth + childFoldersLength;

  const handleCheck = () => {
    onClick(editedName);
  };

  const handleDelete = (id: number) => {
    onDelete(id);
  };

  useEffect(() => {
    setEdiedName(name);
  }, [editedNameId]);

  const handleClick = () => {
    setActiveFolder(id);
  };

  return (
    <div className={styles.card} onClick={handleClick}>
      <FolderIcon className={styles.icon} />
      {isUpdating && editedNameId === id ? (
        <Spinner />
      ) : (
        <div className={styles.nameWrapper}>
          {editedNameId === id ? (
            <>
              <input
                name={name}
                value={editedName}
                className={styles.foldereNameInput}
                onClick={e => e.stopPropagation()}
                onChange={e => {
                  e.stopPropagation();
                  setEdiedName(e.target.value);
                }}
              />
              <div className={styles.editBtnWrapper}>
                <button
                  type="button"
                  className={styles.editNameBtn}
                  onClick={e => {
                    e.stopPropagation();
                    handleCheck();
                  }}
                >
                  <CheckIcon className={styles.icons} />
                </button>
                <button
                  type="button"
                  className={styles.editNameBtn}
                  onClick={e => {
                    e.stopPropagation();
                    setEditedNameId(null);
                  }}
                >
                  <CloseIcon className={styles.icons} />
                </button>
              </div>
            </>
          ) : (
            <>
              <p className={styles.folderName}>{name}</p>
              <button
                type="button"
                className={styles.editBtn}
                onClick={e => {
                  e.stopPropagation();
                  setEditedNameId(id);
                }}
              >
                <EditIcon />
              </button>
            </>
          )}
        </div>
      )}
      <span className={styles.folderCount}>
        {t('objects')} {`(${totalObjectsLength})`}
      </span>
      <ModalConfirm
        title={t('sure_delete_folder')}
        description={t('files_will_deleted_with_folder')}
        onConfirm={() => handleDelete(id)}
      >
        {open => (
          <div onClick={e => e.stopPropagation()} className={styles.deleteBtn}>
            <IconButton onClick={() => open()}>
              <DeleteIcon className={styles.deleteSvg} />
            </IconButton>
          </div>
        )}
      </ModalConfirm>
    </div>
  );
};
